<template>
    <v-container max-width="600">
        <v-card class="pa-4 align-center justify-center">
            <v-card-title>Login</v-card-title>

            <v-card-text>
                <v-form></v-form>
                <v-text-field
                    v-model="email"
                    placeholder="Enter your email address"
                    label="Email"
                    variant="solo-filled"
                    :rules="emailRules"
                >
                    <template #prepend>
                        <v-icon>mdi-email-outline</v-icon>
                    </template>
                </v-text-field>

                <v-text-field
                    v-model="password"
                    :append-inner-icon="passVisible ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="passVisible ? 'text' : 'password'"
                    placeholder="Enter your password"
                    prepend-inner-icon=""
                    :rules="passwordRules"
                    variant="solo-filled"
                    @click:append-inner="passVisible = !passVisible"
                >
                    <template #prepend>
                        <v-icon >mdi-lock-outline</v-icon>
                    </template>
                </v-text-field>
                <v-row align="center">
                    <v-col cols="12" class="d-flex align-center justify-center">
                        <v-btn
                            class="rounded-xl white--text" color="#1ac266" 
                            @click="login"
                            :loading="loading"
                            >
                            <!-- :disabled="btnDissabled" -->
                            Log In
                        </v-btn>
                    </v-col>
                    <v-col cols="12" class="d-flex align-center justify-center">
                        <v-btn
                            class="rounded-xl white--text" color="#1ac266" 
                            @click="toSignUpPage"
                        >
                            Don't Have an Account? Sign Up
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- **TODO** Will need to resize for mobile -->

                <!-- <v-btn
                    size="large"
                    variant="tonal"
                    block
                    @click="ping()"
                >
                    Ping
                </v-btn> -->
                <v-card-text v-if="errorMessage != ''">{{ errorMessage }}</v-card-text>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
// import axios from 'axios'
// import { VDateInput } from 'vuetify/labs/VDateInput'
// import JsonCSV from 'vue-json-csv'
import { useMainStore } from '@/store/store';


export default {
    setup() {
        const store = useMainStore()

        return { store }
    },
    name: 'LoginPage',

    components: {
        // VDateInput,
        // JsonCSV,
    },

    data: () => ({
        email: '',
        password: '',
        passVisible: false,
        errorMessage: '',
        loading: false,

        emailRules: [
            value => {
                if (value) return true

                return 'E-mail is required.'
            },
            value => {
                if (/.+@.+\..+/.test(value)) return true

                return 'E-mail must be valid.'
            },
        ],
        passwordRules: [
            value => {
                if (value) return true

                return 'Password is required.'
            },
        ],
        btnDissabledRules: [
            () => {
                if (this.email && this.password && (/.+@.+\..+/.test(this.email))) return false

                return true
            },
        ],

    }),

    methods: {
        ping(){
            this.store.pingAPI()
        },
        // **TODO Must implement password hashing
        async login() {

            this.loading = true

            if((this.email && this.password && (/.+@.+\..+/.test(this.email))) === false){
                this.errorMessage = "Please enter a valid email and password"
                this.loading = false
                return
            }
            let data = {
                email: this.email,
                password: this.password
            }

            // await console.log('Login data:', data)

            await this.store.login(data)
                .then(() => {
                    this.loading = false
                    // this.$router.go({ path: 'about' })
                    this.$router.push({ path: '/about' })
                    .then(() => {
                        this.$router.go()
                    })
                    // this.setTimeout(() => {
                        
                    // }, timeout);
                    // this.$router.push({ name: 'admin' })
                })
                .catch((error) => {
                    // console.log("Page error:")
                    // console.log(error)
                    this.errorMessage = error.response.data
                    this.loading = false
                })

        //     .then(() => {
            // this.loading = false
            // this.$router.replace({ path: '/' })
        //     })
        //     .catch((error) => {
        //         this.errorMessage = error.message
        //     })
        },
        toSignUpPage(){
            this.$router.push({ name: 'signup' })
        },

    }

}
</script>

<style scoped>
.v-input__prepend .v-icon{
  opacity: 1;
  color: #1ac266;
}
</style>